// extracted by mini-css-extract-plugin
export default {"container":"topLevelLoadingSpinner_container__M9I1P","spinnerContainer":"topLevelLoadingSpinner_spinnerContainer__a+klA","text":"topLevelLoadingSpinner_text__G1J0n"};